function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 5.25,
  transform: "translate(6 6)",
  stroke: "#97A6C5",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.97 18.03a.75.75 0 001.06-1.06l-1.06 1.06zm-2-2l2 2 1.06-1.06-2-2-1.06 1.06z",
  fill: "#97A6C5"
});

var SvgIconSearch24 = function SvgIconSearch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjUuMjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYgNikiIHN0cm9rZT0iIzk3QTZDNSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTEuNDY5NjcgMi41MzAzM0MxLjc2MjU2IDIuODIzMjIgMi4yMzc0NCAyLjgyMzIyIDIuNTMwMzMgMi41MzAzM0MyLjgyMzIyIDIuMjM3NDQgMi44MjMyMiAxLjc2MjU2IDIuNTMwMzMgMS40Njk2N0wxLjQ2OTY3IDIuNTMwMzNaTS0wLjUzMDMzIDAuNTMwMzNMMS40Njk2NyAyLjUzMDMzTDIuNTMwMzMgMS40Njk2N0wwLjUzMDMzIC0wLjUzMDMzTC0wLjUzMDMzIDAuNTMwMzNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNS41IDE1LjUpIiBmaWxsPSIjOTdBNkM1Ii8+Cjwvc3ZnPgo=";
export { SvgIconSearch24 as ReactComponent };